import { render, staticRenderFns } from "./RegionBubble.vue?vue&type=template&id=abb1dafa"
import script from "./RegionBubble.vue?vue&type=script&lang=js"
export * from "./RegionBubble.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports